// extracted by mini-css-extract-plugin
module.exports = {"contentStyles":"styles_contentStyles__2yRR7","image":"styles_image__12GAT","words":"styles_words__2vDLa","placeholder":"styles_placeholder__2URYC"};